export default {
    create : {title : "Add a User", send : "Create"},
    update : {title : "Update User",  send : "Update"}
}